import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import miscFunctions from '../helpers/misc-functions';
import serviceUtil from './serviceUtil';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';

let helpers = {

  getDirectories: (options) => {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/directories?current_company=' + localStorage.current_company_id + filter,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
    .catch(error =>{
      return serviceUtil.resultForError(error);
    });
  },
  getAdminDirectories: (options) => {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/admin/directories/by_company?current_company=' + localStorage.current_company_id + filter,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getDirectory: (directory_id, options) => {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/directories/' + directory_id + '?current_company=' + localStorage.current_company_id + filter,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  createDirectory: (directory, company_id, currentCompanySameAsNew, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/directories?current_company=' + (currentCompanySameAsNew && company_id ? company_id : localStorage.current_company_id) + filter,
      data: {
        event_metadatum: eventMetadatum,
        directory: directory,
        company: company_id,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  updateDirectory: (directory, eventMetadatum, options) => {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/directories/' + directory.id + '?current_company=' + localStorage.current_company_id + filter,
      data: {
        event_metadatum: eventMetadatum,
        directory: directory,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return miscFunctions.mapApiJson(response.data);
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteDirectory: (directory_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/directories/' + directory_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  createChildDirectory: (parent, directory, eventMetadatum, options) => {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/directories/' + parent.id + '/child?current_company=' + localStorage.current_company_id + filter,
      data: {
        event_metadatum: eventMetadatum,
        directory: directory,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getProjectManagers(options) {
    let filter = '';
    if (options && options.recordDescriptor) {
      filter = '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/directories/project_managers?current_company=' + localStorage.current_company_id + filter,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;
  



// WEBPACK FOOTER //
// ./src/services/directoriesService.js